export default __webpack_public_path__ + "i18n/translations/translation-sv.3f190522.json";